import { useQuery } from "@tanstack/react-query";
import { Loading, Panel } from "components/panels";
import { Pagination } from "pagination";
import React from "react";
import { RefreshLogRow } from "./RefreshLogRow";

interface Props {
  externalCalendarId: number
}

export const RefreshLogPanel = (props: Props) => {
  const [page, setPage] = React.useState(1);
  const perPage = 10;

  const query = useQuery({
    queryKey: ["refreshLog", props.externalCalendarId, page],
    queryFn: async () => window.CoreApi.ExternalCalendar.ListRefreshLog({
      externalCalendarId: props.externalCalendarId,
      page,
      perPage
    }).then(r => r.data)
  });

  return <Panel
    title="Refresh Log"
    panelClassName="s1_related-feature-panel"
    isLoading={query.isLoading}
    hasData={query.data?.pagination.total > 0}
    pagination={<Pagination
      small
      onPaginate={(page) => { setPage(page); }}
      paginationData={{
        page,
        perPage,
        total: query.data?.pagination.total ?? 0,
        pageCount: query.data?.pagination.pageCount ?? 0,
        maxPerPage: perPage
      }}
    />}
  >
    {query.data != null && <div className="list-with-gaps line-layout">
      <div className="list-with-gaps-body">
        {query.data.data.map((log, idx) => <RefreshLogRow key={idx} log={log} />)}
      </div>
    </div>}

    {query.isLoading && <Loading />}
  </Panel>
}